<template>
    <v-footer
        app
        dark
        inset
        color="primary"
        class="application-footer"
    >
        <v-card
            class="flex primary"
            flat
            tile
            dark
        >
            <v-card-text class="py-1 white--text overline text-center">
                Capital Legacy Solutions (Pty) Ltd is an Authorised Financial Services Provider.
                The Legacy Protection Plan&trade; is underwritten by Guardrisk Life Ltd.
            </v-card-text>
        </v-card>
    </v-footer>
</template>
<script>
    export default {
        name: 'Footer',
        data() {
            return {}
        },
        computed: {},
        methods: {}
    }
</script>
